import { render, staticRenderFns } from "./putadd.vue?vue&type=template&id=c0becc14&scoped=true"
import script from "./putadd.vue?vue&type=script&lang=js"
export * from "./putadd.vue?vue&type=script&lang=js"
import style0 from "./putadd.vue?vue&type=style&index=0&id=c0becc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0becc14",
  null
  
)

export default component.exports